<template>
	<BaseInput
		:value="value"
		class="base-text-input"
		type="text"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import BaseInput from './BaseInput.vue';

export default {
	name: 'BaseTextInput',
	components: {
		BaseInput,
	},
	props: {
		value: {
			type: String,
			default: () => '',
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/BaseTextInput.vue